export default {

    LOAD_SCHEDULES(state, schedules) {
        state.items = schedules;
    }

}